import React, { useState } from "react";
import { Mail, Phone, MapPin, Send, Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { apiClient } from "@/lib/api";

export default function Contact() {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await apiClient.post("/contact", form);
      toast.success(t("contact.sent"));
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(detail
        ? t("contact.failDetail", { detail })
        : t("contact.failNet"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 lg:grid-cols-2 gap-10">
      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-brand-red mb-2">{t("contact.kicker")}</div>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold mb-3">{t("contact.title")}</h1>
        <p className="text-mute mb-6">{t("contact.intro")}</p>
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-elevated grid place-items-center"><Phone className="w-4 h-4" /></div>
            <div>
              <div className="text-xs uppercase tracking-widest text-mute">{t("contact.phoneLabel")}</div>
              <div className="font-semibold">+33 7 58 26 24 47</div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-elevated grid place-items-center"><Mail className="w-4 h-4" /></div>
            <div>
              <div className="text-xs uppercase tracking-widest text-mute">{t("contact.emailLabel")}</div>
              <div className="font-semibold">contact@neldaari.com</div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-elevated grid place-items-center"><MapPin className="w-4 h-4" /></div>
            <div>
              <div className="text-xs uppercase tracking-widest text-mute">{t("contact.officeLabel")}</div>
              <div className="font-semibold">{t("contact.office")}</div>
            </div>
          </div>
        </div>
      </div>
      <form onSubmit={submit} data-testid="contact-form" className="bg-white border border-sand rounded-2xl p-6 space-y-3">
        <input value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} required placeholder={t("contact.namePh")} data-testid="contact-name" className="w-full bg-elevated rounded-xl px-4 py-3 outline-none" />
        <input value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} required type="email" placeholder={t("contact.emailPh")} data-testid="contact-email" className="w-full bg-elevated rounded-xl px-4 py-3 outline-none" />
        <textarea value={form.message} onChange={(e) => setForm({...form, message: e.target.value})} required placeholder={t("contact.messagePh")} rows={5} data-testid="contact-message" className="w-full bg-elevated rounded-xl px-4 py-3 outline-none" />
        <button type="submit" data-testid="contact-submit" className="w-full rounded-full bg-brand-red text-white py-3 font-semibold inline-flex items-center justify-center gap-2"><Send className="w-4 h-4" /> {t("contact.send")}</button>
      </form>
    </div>
  );
}
